module.exports = __webpack_public_path__ + "static/media/country-4.a414969d.jpg";